import ReactDom from 'react-dom';
import './Modal.css';

function Backdrop(props) {
  return <div className="backdrop" onClick={props.onOkClick} />;
}

export function Loader() {
  return (
    <div
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        zIndex: 1500,
      }}
    >
      <div className="spinner-3" />
    </div>
  );
}

export function LoginLoader() {
  return <div className="spinner-3" />;
}

function Spinner(props) {
  return (
    <>
      {ReactDom.createPortal(
        <Backdrop onOkClick={props.onOkClick} />,
        document.getElementById('backdrop-root'),
      )}
      {ReactDom.createPortal(
        <Loader />,
        document.getElementById('overlay-root'),
      )}
    </>
  );
}

export default Spinner;
